import React from 'react'
import './Style/Header.css'
import Logo from '../Image/logo.png'
import { connections } from './modal'
function Header() {
  return <div className='invoice-header'>

      <div className='svg'>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path fill="#DB1433" fill-opacity="1" d="M0,96L120,85.3C240,75,480,53,720,80C960,107,1200,181,1320,218.7L1440,256L1440,0L1320,0C1200,0,960,0,720,0C480,0,240,0,120,0L0,0Z"></path>
      </svg>
      </div>


    <div className='header-info'>
        <img src={Logo} alt='logo' />
        <ul>
            <li> <i className='fa fa-phone'></i> {connections.connection.number} </li>
            <li> <i className='fa fa-paper-plane'></i> {connections.connection.email} </li>
            <li> <i className='fa fa-map-marker'></i> {connections.connection.address} </li>
        </ul>
    </div>

  </div>
}

export default Header